import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RemoteComponent from "@/components/RemoteComponent";
import { useHostMicroFrontendApi } from "@/shared/microfrontend/hooks/useHostMicroFrontend";
import { Button } from "primereact/button";
import React, { useState } from "react";
const ModePreview = ({ formData, setShowpreviewDialog, }) => {
    // console.log("fff", formData);
    const [loadError, setLoadError] = useState(null);
    const mfApi = useHostMicroFrontendApi();
    const handleRemoteLoad = () => {
        console.log("[WidgetsWrapper] Remote component loaded successfully");
        // setIsRemoteLoaded(true);
        if (mfApi && "setRemoteLoaded" in mfApi) {
            mfApi.setRemoteLoaded(true);
        }
    };
    const handleRemoteError = (error) => {
        console.error("[WidgetsWrapper] Failed to load remote component:", error);
        setLoadError(error.message);
        // setIsRemoteLoaded(false);
        if (mfApi && "setRemoteLoaded" in mfApi) {
            mfApi.setRemoteLoaded(false);
        }
    };
    return (_jsxs("div", { className: "w-full h-full flex flex-col justify-between", children: [_jsx("div", { className: "flex justify-between items-center", children: _jsx(Button, { label: "Go Back", icon: "pi pi-chevron-left", className: "rounded-[8px] text-[#5928ED] py-2 px-4 border-[#5928ED]", outlined: true, onClick: () => setShowpreviewDialog(false) }) }), _jsx("div", { className: " h-[calc(100%-40px)] overflow-y-auto", children: _jsx(React.Suspense, { fallback: _jsxs("div", { className: "flex flex-col items-center justify-center gap-y-5 h-full", children: [_jsx("div", { className: "animate-spin rounded-full h-10 w-10 border-b-2 border-gray-900 mb-2" }), _jsx("p", { className: "font-heading text-2xl", children: "Loading Remote App..." })] }), children: loadError ? (_jsx("div", { className: "flex items-center justify-center h-full", children: _jsxs("div", { className: "text-center text-red-500 py-10", children: [_jsx("p", { children: "Failed to load remote component:" }), _jsx("p", { children: loadError })] }) })) : (_jsx(RemoteComponent, { url: formData?.url, scope: "remote", 
                        // module="./ComponentsWrapper"
                        module: `./${formData?.module}`, onLoad: handleRemoteLoad, onError: handleRemoteError })) }) })] }));
};
export default ModePreview;
